<template>
  <CContainer>
    <CSidebar class="asideBar bg-white" style="box-shadow: none" aside unfoldable>
      <section v-if="viewSidebar">
        <SideBar
          :loading="loadingBalance"
          :campaignStatus="campaignStatus[campaign.campaignStatus]"
          :campaignBalance="campaignBalance"
          @cancel-campaign="cancelCampaign()"
        />
      </section>
    </CSidebar>
    <CWrapper class="justify-content-between">
      <transition name="fade">
        <MenssageAlert :messages="messages" />
      </transition>
      <div class="pb-4">
        <Header
          :campaignName="campaign.name"
          :pageTitle="$t('campaign.campaignResume.pageTitle')"
          :campaignStatus="campaignStatus[campaign.campaignStatus]"
          :loading="loadingCampaigns"
          @cancel-campaign="cancelCampaign()"
        />

        <div v-if="loadingCampaigns">
          <div class="d-flex justify-content-center align-items-center" style="height: 70vh">
            <LoadingSpinner />
          </div>
        </div>
        <div v-if="!loadingCampaigns">
          <div v-for="(workflow, index) in campaign.campaignWorkflow.values" :key="index">
            <EmailPanel v-if="workflow.channel == 1" :workflow="workflow" />
            <SMSPanel v-if="workflow.channel == 2" :workflow="workflow" :totalSMSCount="findSMSTotal(workflow.schedulingId)" />
          </div>
        </div>

        <!-- <EmailPanel /> -->
      </div>
    </CWrapper>
  </CContainer>
</template>

<script>
import Header from '../components/Summary/Header.vue'
import SideBar from '../components/Summary/SideBar.vue'
import SMSPanel from '../components/Summary/SMSPanel.vue'
import EmailPanel from '../components/Summary/EmailPanel.vue'
import LoadingSpinner from '../components/Summary/LoadingSpinner.vue'
import services from '@/services.js'
import MenssageAlert from '@/components/MenssageAlert'

const campaignStatus = {
  1: 'Draft',
  2: 'Calculating',
  3: 'Ready-to-Send',
  4: 'Sent',
  5: 'On-going',
  6: 'Scheduled',
  7: 'Deleted',
  8: 'Pending-Balance',
  9: 'Balance-Updated',
}

export default {
  components: {
    Header,
    SideBar,
    SMSPanel,
    EmailPanel,
    LoadingSpinner,
    MenssageAlert,
  },
  data() {
    return {
      campaignStatus,
      campaign: {},
      campaignBalance: {
        currentBalance: {
          channels: {
            email: {
              values: [{ balance: 0 }],
            },
            sms: {
              values: [{ balance: 0 }],
            },
          },
        },
      },
      messages: [],
      loadingCampaigns: true,
      loadingBalance: true,
      viewSidebar: true,
    }
  },
  methods: {
    findSMSTotal(workflowSchedulingId) {
      return this.campaign.campaignSummary.schedulingSummaries.find((elm) => elm.schedulingId == workflowSchedulingId).totalSMSCount
    },
    getFlag(key) {
      return countries.find((elm) => elm.code.toUpperCase() === key.toUpperCase())?.flag
    },
    getCampaign(organizationId, campaignId) {
      this.loadingCampaigns = true
      services
        .getCampaign(organizationId, campaignId)
        .then((res) => {
          this.campaign = res.data.data
        })
        .finally(() => (this.loadingCampaigns = false))
    },
    getCampaignBalance(organizationId, campaignId) {
      this.loadingBalance = true
      services
        .getCampaignSummaryBalance(organizationId, campaignId)
        .then((res) => {
          this.campaignBalance = res.data.data

          this.viewSidebar = false
          this.$nextTick(() => {
            this.viewSidebar = true
          })
        })
        .finally(() => (this.loadingBalance = false))
    },
    cancelCampaign() {
      this.messages = []
      let campaignId = this.$route.params.campaignId
      let organizationId = this.$route.params.organizationId
      services
        .cancelCampaign(organizationId, campaignId)
        .then((res) => {
          this.$router.push({ name: 'campaignCreator', params: { campaignId } })
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.title || response.data.message || 'Erro',
          })
        })
    },
  },
  mounted() {
    if (this.$route.params.campaignId) {
      let organizationId = this.$route.params.organizationId
      let campaignId = this.$route.params.campaignId
      this.getCampaign(organizationId, campaignId)
      this.getCampaignBalance(organizationId, campaignId)
    }
  },
}
</script>

<style scoped lang="scss" src="@/assets/scss/_flow.scss"></style>

<style lang="scss" scoped>
.asideBar {
  position: absolute;
  right: 0;
  z-index: 100 !important;
  bottom: initial;
  height: 100%;
  overflow-y: auto;
  overflow-x: none;

  .c-sidebar-nav {
    padding-bottom: 0;
  }

  .minimizer {
    position: relative;
  }
}

.sticky {
  position: sticky;
  top: 20px;
}

.send-cursor {
  cursor: pointer;
}

.font-balance {
  font-size: $font-size-lg;
  font-weight: 300;
}

.resume-balance-area {
  background-color: $white;
}

.font-title-channels {
  font-size: $font-size-md;
}

.font-title-values {
  font-size: $font-size-lg;
  font-weight: 300;
}

.font-title-locations {
  font-size: $font-size-md;
  font-weight: 400;
}

.text-warning {
  color: $warning;
}

.scroll-area-locations {
  overflow-y: auto;
  min-height: 270px;
  max-height: 270px;
}

.border-locations {
  border-bottom: 1px solid $gray-200;
}
</style>
